// import { Link } from "gatsby"
import React, { useState } from "react"
import { useStaticQuery, graphql, StaticQuery } from "gatsby"

import "./header.scss"
import MainMenu from "../main-menu/main-menu"
import PopupNotification from "../../atoms/popup-notification/popup-notification"
import useHeaderQuery from "../../../utils/useHeaderQuery"

const Header = (props) => {
  const {allContentfulNolHome, allContentfulNolMenuDeNavegacion} = useHeaderQuery()
  
  const {
    setCommondModal,
    setInfoUser,
    mobile,
    notificationState,
    setnotificationState,
    logStatus,
  
  } = props

  var navSubMenuTitles2 = allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0].enlaceSubMenu
  var navSubMenuTitles3 = allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[2].enlaceSubMenu
  var navSubMenuTitles5 = allContentfulNolMenuDeNavegacion.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[1].enlaceSubMenu

  var navegationMenus = {
    navMenu1: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion1,
    navMenu2: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion2,
    navMenu3: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion3,
    navMenu4: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion4,
    navMenu5: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion5,
    navMenu6: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion6,
    navMenu7: allContentfulNolHome.edges.filter(
      e => e.node.node_locale === process.env.LOCALE
    )[0].node.menuNavegacion7,
  }
 
  const [active_menu, setMenu] = useState("")

  const closeMenu = () => {
    setMenu("")
  }

  const changeMenu = menu => {
    setMenu(menu)
  }

  var logoUrl = allContentfulNolHome.edges.filter(
    e => e.node.node_locale === process.env.LOCALE
  )[0].node.logoNosotras

  return (
    <header>
      {props.modalActive}
      {props.commondModal}
      {notificationState !== null && (
        <PopupNotification
          mobile={mobile}
          notificationState={notificationState}
          setnotificationState={setnotificationState}
        />
      )}

      <MainMenu
        popupLogin={props.popupLogin}
        logout={props.logout}
        isLog={props.isLog}
        logStatus={logStatus}
        infoUser={props.infoUser}
        setInfoUser={setInfoUser}
        logoInfo={logoUrl}
        mobile={props.mobile}
        changeMenu={changeMenu}
        activeMenu={active_menu}
        closeMenu={closeMenu}
        navegationMenus={navegationMenus}
        navSubMenuTitles2={navSubMenuTitles2}
        navSubMenuTitles3={navSubMenuTitles3}
        navSubMenuTitles5={navSubMenuTitles5}
        setCommondModal={setCommondModal}
      />
    </header>
  )
}

export default Header


